Ext.define('SA.model.CustomLocation', {
    extend: 'SA.model.LocationItem',

    constructor({intId, stringId}) {
        this.callParent(arguments);

        this.intId = intId;
        this.stringId = stringId;
    },

    getStringId() {
        return this.stringId;
    },

    toItem() {
        return {type: 'customLocation', id: this.intId};
    }
});